// Module imports
import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';

// Custom reducer imports
import quickSearchReducer from '../search/reducers/quickSearchReducer';
import itemSearchReducer from '../search/reducers/itemSearchReducers';
import tagReducer from '../search/reducers/tagReducers';
import categoryReducer from '../search/reducers/categoryReducers';
import itemGetReducer from '../items/reducers/itemGetReducer';
import itemsetGetReducer from '../itemsets/reducers/itemsetGetReducer';
import appearanceGetReducer from '../appearances/reducers/appearanceGetReducer';
import appearanceSearchReducer from '../appearances/reducers/appearanceSearchReducer';
import appearanceSlotReducer from '../appearances/reducers/slotReducers';
import appearanceTypeReducer from '../appearances/reducers/typeReducers';

const appReducer = combineReducers({
  search: quickSearchReducer,
  tags: tagReducer,
  categoryState: categoryReducer,
  itemSearch: itemSearchReducer,
  itemState: itemGetReducer,
  itemsetState: itemsetGetReducer,
  appearanceState: appearanceGetReducer,
  appearanceSearch: appearanceSearchReducer,
  form: formReducer,
  routing: routerReducer,
  appearanceSlots: appearanceSlotReducer,
  appearanceTypes: appearanceTypeReducer,
});


export default (state, action) => appReducer(state, action);



// WEBPACK FOOTER //
// ./src/store/rootReducer.jsx